module.exports = __webpack_public_path__ + "img/qr_code2.ca1981c2.png";